import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const UnbilledExpenseItemsViewChunk = lazy(() =>
  import('@webapp/modules/accounts-payable/feature-sets/UnbilledExpenseItemsView').then(
    ({ UnbilledExpenseItemsView }) => ({
      default: UnbilledExpenseItemsView,
    })
  )
)

export const UnbilledExpenseItemsPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.unbilledExpenseItemsPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.unbilledExpenseItemsPageTitle),
        },
      ]}
    >
      <UnbilledExpenseItemsViewChunk />
    </Page>
  )
}
